export enum MIX_PANEL_CONSTANTS {
  LAND_IN_SPACE = "Land in space",
  STATE_ON = "State on",
  STATE_OFF = "State off",
  POWER_UPS = "Power ups",
}
